import PropTypes from 'prop-types'
import React from 'react'
import {FormattedMessage} from 'react-intl'
import Checkbox from '../checkbox'
import Link from '../link'

const TermsAndConditions = ({testid, value, onChange}) => {
    onChange = onChange || ((newValue) => (value = newValue))

    const values = {
        privacy: (
            <Link href="/customer-service/legal/privacy-policy.html" isExternal size="sm">
                <FormattedMessage defaultMessage="Privacy Policy" id="footer.link.privacy_policy" />
            </Link>
        ),

        terms: (
            <Link href="/customer-service/legal/terms/terms.html" isExternal size="sm">
                <FormattedMessage
                    defaultMessage="Terms and Conditions"
                    id="footer.link.terms_conditions"
                />
            </Link>
        )
    }

    return (
        <Checkbox
            size="sm"
            name="tocOptIn"
            isChecked={value}
            data-testid={testid}
            onChange={(e) => {
                onChange(e.target.checked)
            }}
            isRequired={true}
        >
            <FormattedMessage
                defaultMessage="I read and agree to the {privacy} and {terms}."
                id="global.tnc"
                values={values}
            />
        </Checkbox>
    )
}

TermsAndConditions.propTypes = {
    testid: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func
}

export default TermsAndConditions
